const links = {
  Github: "https://github.com/PJValgento",
};
export default links;
